import React from "react";
import "./index.scss";
import Error from "../../../assets/images/error.png";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "../../../hooks/useTranslation";

function ErrorComponent() {
  const { t } = useTranslation();

  const refresh = () => {
    window.location.reload();
  };

  return (
    <>
      <div className="wrapperError">
        <img className="imgError" src={Error} />
        <Typography className="title">Hubungi Administrasi</Typography>
        <Typography className="titleDesc">
          Terjadi kendala mohon hubungi administrator kami.
        </Typography>
        <Button
          variant="contained"
          className="btnRefresh"
          id="btn_refresh"
          onClick={refresh}
        >
          {t("refresh")}
        </Button>
      </div>
    </>
  );
}

export default ErrorComponent;
